// Fucntional component that queroies the salary bases and displays them in a table

import { useQuery } from '@apollo/client'
import { Loader } from '@ur-solutions/react-components'
import { useTranslate } from '@ur-solutions/react-hooks'
import { Table } from 'components/Table'
import { ModuleTitle } from 'components/Title'
import { format } from 'date-fns'
import React from 'react'
import { useNavigate } from 'react-router'
import styled from 'styled-components'
import { getNodes } from 'utils/graphql'
import { SALARY_BASES } from './queries'

const Wrapper = styled.div`
  ${props => props.theme.layout.default};
`

const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`

const ClickableRow = styled.tr`
  cursor: pointer;
`

export const SalaryBases: React.CFC = () => {
  const translations = useTranslate({
    name: 'common.name',
    created: 'common.created',
    edit: 'common.edit',
    delete: 'common.delete',

    salaryBases: 'salary.salary-bases',
  })

  const navigate = useNavigate()

  const { data, loading } = useQuery(SALARY_BASES)

  if (loading) return <Loader.Dots />

  const salaryBases = getNodes(data?.allSalaryBases)

  return (
    <Wrapper>
      <TitleWrapper>
        <ModuleTitle>{translations.salaryBases}</ModuleTitle>

        {loading && <Loader.Spinner size={24} />}
      </TitleWrapper>

      <Table noBorders rowHoverBackground="gray10">
        <thead>
          <tr>
            <th>{translations.name}</th>
            <th>{translations.created}</th>
          </tr>
        </thead>

        <tbody>
          {salaryBases.map(salaryBase => (
            <ClickableRow
              key={salaryBase.id}
              onClick={() => navigate(`/salary-bases/${salaryBase.id}`)}
            >
              <td>{salaryBase.name}</td>
              <td>{format(new Date(salaryBase.createdAt), 'dd.MM.yyyy')}</td>
            </ClickableRow>
          ))}
        </tbody>
      </Table>
    </Wrapper>
  )
}
